import { FC } from 'react';
import { ITrialCalendarSlot } from '../../../../entities/trialLesson';
import { formatTrialTime, getTrialSlotDateEnd } from '../../lib/date';
import classes from './trialAvailableSlots.module.scss';

interface IProps {
    slots: ITrialCalendarSlot[];
    durationSlots: number;
    onSelect: (period: {startsAt: Date; durationSlots: number}) => void;
}

export const TrialAvailableSlots: FC<IProps> = ({slots, durationSlots, onSelect}) => {
    const availableSlots = slots.filter(slot =>
        slot.availabilityStatus === 'TRIAL_SLOT_AVAILABILITY_STATUS_AVAILABLE'
        && (slot.availableTutorsCount ?? 0) > 0
        && new Date(slot.startsAt).getTime() >= Date.now(),
    );

    if(!availableSlots.length) return <p className={classes.empty}>Нет доступных слотов</p>;

    return (
        <ul className={classes.slots} aria-label="Доступные слоты">
            {availableSlots.map(slot => {
                const startsAt = new Date(slot.startsAt);
                const endsAt = getTrialSlotDateEnd(startsAt, durationSlots);
                return (
                    <li key={slot.startsAt}>
                        <button
                            type="button"
                            className={classes.slot}
                            disabled={!slot.availableActions.includes('CALENDAR_SLOT_ACTION_CREATE_TRIAL_LESSON')}
                            onClick={() => onSelect({startsAt, durationSlots})}
                        >
                            {formatTrialTime(startsAt)}–{formatTrialTime(endsAt)} ({slot.availableTutorsCount})
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};
